import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-773a2144"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-3 right-icon" }
const _hoisted_2 = { class: "columns is-multiline" }
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(['content-item-wrapper', 'column', 'is-4'])
}
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(['content-item', 'padding-b-standard'])
}
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(['content-item', 'padding-b-standard'])
}
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass(['content-item', 'padding-b-standard'])
}
const _hoisted_7 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['content-item', 'padding-b-standard'])
}
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass(['content-item-wrapper', 'column', 'is-4'])
}
const _hoisted_9 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['content-item', 'padding-b-standard'])
}
const _hoisted_10 = {
  class: /*#__PURE__*/_normalizeClass(['content-item-wrapper', 'column', 'is-4'])
}
const _hoisted_11 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['content-item', 'padding-b-standard']),
  style: {"order":"3"}
}
const _hoisted_12 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(['content-item', 'padding-b-standard'])
}
const _hoisted_13 = {
  key: 2,
  class: /*#__PURE__*/_normalizeClass(['content-item', 'padding-b-standard'])
}

import csHelper from "@/utils/product/content-structure-helpers";
import contentAPI from "@/services/content-api";
import { WorkflowState } from "@/models/workflow.model";
import ContentName from "@/components/right-sidebars/content-sidebar/ContentName.vue";
import ContentLocation from "@/components/right-sidebars/content-sidebar/content-location/ContentLocation.vue";
import ContentDescription from "@/components/right-sidebars/content-sidebar/ContentDescription.vue";
import ContentMetadata from "@/components/right-sidebars/content-sidebar/content-metadata/ContentMetadata.vue";
import ContentWorkflow from "@/components/right-sidebars/content-sidebar/content-workflow/ContentWorkflow.vue";
import ContentActivityLog from "@/components/right-sidebars/content-sidebar/ContentActivityLog.vue";
import AuthoringTool from "@/components/right-sidebars/content-sidebar/authoring-tool/AuthoringTool.vue";
import CurriculumTags from "@/components/right-sidebars/content-sidebar/curriculum/CurriculumTags.vue";
import {
  ContentStructureSection,
  GeneratedContentStructure
} from "@/models/content-structure.model";
import { ProductItem, ProductPermission } from "@/models/product.model";
import { OrganizationUser } from "@/models/user.model";
import * as xApiHelper from "@/utils/product/x-api-helper";
import { XAPIError, XAPIErrors } from "@/models/x-api.model";
import ContentPreview from "@/components/right-sidebars/content-sidebar/ContentPreview.vue";
import { isEqual } from "lodash";
import RightSidebar from "@/components/right-sidebars/ui/RightSidebar.vue";
import ContentIdentifiers from "@/components/right-sidebars/content-sidebar/ContentIdentifiers.vue";
import EditContentPath from "@/components/popups/EditContentPath.vue";
import { AssetLocation } from "@/models/assets.model";
import { AxiosResponse } from "axios";
import { MetadataInstance } from "@/models/product-section.model";
import { getDeadlineByWorkflowState } from "@/utils/tasks-helpers";
import {
  mdiChevronLeft,
  mdiChevronRight,
  mdiDelete,
  mdiDotsHorizontal,
  mdiPackageUp
} from "@mdi/js";
import { computed, onMounted, ref, watch } from "vue";
import { useUIGeneralStore } from "@/stores/ui-general.store";
import { useUIContentStore } from "@/stores/ui-content.store";
import { useUsersStore } from "@/stores/users.store";
import { useContentStore } from "@/stores/content.store";
import { showDialog, showToast } from "@/services/notification-manager";
import { useFeatureFlags } from "@/composables/feature-flags";
import { useCurriculumManager } from "@/composables/curriculums-manager";
import { useRoute } from "vue-router";
import { useProductsStore } from "@/stores/products.store";
import { useContentStructureStore } from "@/stores/content-structure.store";
import { PRODUCT } from "@/constants/product.constants";
import { X_API } from "@/constants/xapi.constants";
import { TOOLS } from "@/constants/template.constants";
import { SECTION } from "@/constants/assets.constant";
import { MESSAGES } from "@/constants/messages.constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentSidebar',
  setup(__props) {

const route = useRoute();
const uiGeneralStore = useUIGeneralStore();
const uiContentStore = useUIContentStore();
const usersStore = useUsersStore();
const contentStore = useContentStore();
const productsStore = useProductsStore();
const contentStructureStore = useContentStructureStore();

const product = computed<ProductItem | undefined>(() => {
  if (
    productsStore.areProductDetailsLoading ||
    !uiContentStore.sectionToDisplay
  ) {
    return undefined;
  }
  return productsStore.productDetails?.find((e: ProductItem): boolean => {
    return (
      !!uiContentStore.sectionToDisplay &&
      e.id === Number(uiContentStore.sectionToDisplay.productId)
    );
  });
});
const structure = computed<GeneratedContentStructure | undefined>(() => {
  if (
    contentStructureStore.isContentStructureLoading ||
    !uiContentStore.sectionToDisplay
  ) {
    return undefined;
  }
  return contentStructureStore.contentStructure?.find(
    (e: GeneratedContentStructure): boolean => {
      return (
        !!uiContentStore.sectionToDisplay &&
        e.product_id === uiContentStore.sectionToDisplay.productId
      );
    }
  );
});
const isUpdating = computed<boolean>(() => {
  return (
    productsStore.areProductDetailsLoading ||
    contentStructureStore.isContentStructureUpdating
  );
});

const hasEditPermission = computed<boolean>(() => {
  return (
    !!product.value &&
    product.value.allocated_permissions.some(
      (e: ProductPermission): boolean => {
        return e.id === PRODUCT.PERMISSIONS.editContentStructure;
      }
    )
  );
});
const canEditContent = computed<boolean>(() => {
  return uiGeneralStore.isEditModeEnabled && hasEditPermission.value;
});

const section = computed<ContentStructureSection | undefined>(() => {
  if (structure.value?.rootSection && uiContentStore.sectionToDisplay) {
    const descendentSection: ContentStructureSection | null =
      csHelper.findDescendentSection(
        structure.value.rootSection,
        uiContentStore.sectionToDisplay.sectionId
      );
    return descendentSection ? descendentSection : undefined;
  }
  return undefined;
});
const isAContentObject = computed<boolean>(() => {
  return !!section.value && TOOLS.isContentObject(section.value.type.category);
});

const workflowStates = computed<WorkflowState[]>(() => {
  return product.value && section.value?.workflow_id
    ? csHelper.getWorkflowStatesForSection(
        product.value,
        section.value.workflow_id
      )
    : [];
});
const hasWorkflowStates = computed<boolean>(() => {
  return !!workflowStates.value.length && isAContentObject.value;
});
const canShowWorkflow = computed<boolean>(() => {
  return (
    hasWorkflowStates.value && !!workflowStates.value.length && !!product.value
  );
});
const currentState = computed<WorkflowState | undefined>(() => {
  return section.value?.workflow_id && product.value
    ? csHelper.getCurrentState(
        product.value,
        section.value.state_transitions,
        section.value.workflow_id
      )
    : undefined;
});

const sectionExternalId = computed<string>(() => {
  return !!section.value?.client_external_id
    ? section.value.client_external_id
    : "Not set";
});
const path = computed<AssetLocation[]>(() => {
  if (section.value && structure.value?.rootSection) {
    return csHelper.getPathToSectionWithIds(
      structure.value.rootSection,
      section.value.id
    );
  }
  return [];
});
const showContentDescription = computed<boolean>(() => {
  return (
    hasWorkflowStates.value &&
    (canEditContent.value || (!!section.value && !!section.value.instruction))
  );
});
const deadline = computed<number | undefined>(() => {
  if (section.value && currentState.value && product.value) {
    return getDeadlineByWorkflowState(
      section.value,
      currentState.value,
      product.value
    );
  }
  return undefined;
});
const assignedUsers = computed<OrganizationUser[]>(() => {
  if (!usersStore.users) {
    return [];
  }
  return usersStore.users.filter((userToCheck: OrganizationUser) => {
    if (currentState.value) {
      return currentState.value.users.some(
        (assignedUserId: number): boolean => {
          return assignedUserId === userToCheck.id;
        }
      );
    }
    return false;
  });
});
const displayedMetadata = computed<MetadataInstance[]>(() => {
  return section.value
    ? section.value.metadata_instances.filter((instance: MetadataInstance) => {
        return (
          (instance.metadata_definition.type === "Text Free" &&
            instance.authored_text) ||
          (instance.metadata_definition.type !== "Text Free" &&
            instance.metadata_definition.metadata_allocated_values.length > 0)
        );
      })
    : [];
});
const isMetadataVisible = computed<boolean>(() => {
  return (
    displayedMetadata.value.length > 0 ||
    (canEditContent.value &&
      !!section.value &&
      section.value.metadata_instances.length > 0)
  );
});

const {
  curriculumConceptsGuidsFromProductSections,
  curriculumJson,
  setCurriculumJson,
  resetCurriculumData,
  conceptsFromXml,
  xmlParsedSuccessfully,
  isCurriculumLoading,
  topicsFromXml
} = useCurriculumManager();
const doesProductHaveACurriculum = computed<boolean>(() => {
  return !!product.value && product.value.curriculum_id !== null;
});
const isCurriculumEnabledForSectionType = computed<boolean>(() => {
  return (
    !!section.value &&
    !section.value.isRoot &&
    section.value.type.name !== "Folder"
  );
});
const isCurriculumTagsVisible = computed<boolean>(() => {
  if (
    !!product.value &&
    doesProductHaveACurriculum.value &&
    isCurriculumEnabledForSectionType.value
  ) {
    return (
      !!curriculumConceptsGuidsFromProductSections(product.value).length ||
      (!curriculumConceptsGuidsFromProductSections(product.value).length &&
        canEditContent.value)
    );
  }
  return false;
});
onMounted(() => {
  if (!curriculumJson.value && product.value && product.value.curriculum_id) {
    setCurriculumJson(product.value.curriculum_id);
  }
});
watch(
  () => product.value?.curriculum_id,
  newVal => {
    resetCurriculumData();
    if (newVal) {
      setCurriculumJson(newVal);
    }
  }
);

const currentXAPIErrors = ref<string[]>([]);
const XAPIMetadataErrors = ref<string[]>([]);
const XAPIAuthoringToolErrors = ref<string[]>([]);
const currentXAPIWarnings = ref<string[]>([]);
const XAPIQuestionsWarnings = ref<string[]>([]);
const getMetadataErrors = (): string[] => {
  return currentXAPIErrors.value.filter((error: string): boolean => {
    return error.includes(X_API.ERRORS.metadataValueMissing);
  });
};
const getExternalLinkErrors = (): string[] => {
  return currentXAPIErrors.value.filter((error: string): boolean => {
    return (
      error.includes(X_API.ERRORS.externalLinkNotSet) ||
      error.includes(X_API.ERRORS.invalidExternalLink)
    );
  });
};
const getHTMLErrors = (): string[] => {
  return currentXAPIErrors.value.filter((error: string): boolean => {
    return error.includes(X_API.ERRORS.noHTMLDocumentAuthored);
  });
};
const getQuestionErrors = (): string[] => {
  return currentXAPIErrors.value.filter((error: string): boolean => {
    return (
      error.includes(X_API.ERRORS.noQuestionAuthored) ||
      error.includes(X_API.ERRORS.emptyQuestion) ||
      error.includes(X_API.ERRORS.noInteractions) ||
      error.includes(X_API.ERRORS.emptyChoices) ||
      error.includes(X_API.ERRORS.noCorrectAnswers) ||
      error.includes(X_API.ERRORS.lessThan2Choices) ||
      error.includes(X_API.ERRORS.interactionTypeNotSelected)
    );
  });
};
const getQuestionWarnings = (): string[] => {
  return currentXAPIWarnings.value.filter((error: string): boolean => {
    return (
      error.includes(X_API.ERRORS.hintNotAdded) ||
      error.includes(X_API.ERRORS.solutionNotAdded)
    );
  });
};
const collectXAPIErrors = (): void => {
  currentXAPIErrors.value = [];
  currentXAPIWarnings.value = [];
  const currentErrors = uiContentStore.XAPIErrors
    ? uiContentStore.XAPIErrors.contentErrors.find(
        (error: XAPIError): boolean => {
          return !!section.value && error.sectionId === section.value.id;
        }
      )
    : undefined;
  const currentWarnings = uiContentStore.XAPIErrors
    ? uiContentStore.XAPIErrors.contentWarnings.find(
        (error: XAPIError): boolean => {
          return !!section.value && error.sectionId === section.value.id;
        }
      )
    : undefined;
  currentXAPIErrors.value = currentErrors ? [...currentErrors.errors] : [];
  currentXAPIWarnings.value = currentWarnings
    ? [...currentWarnings.errors]
    : [];
  XAPIAuthoringToolErrors.value = [
    ...getExternalLinkErrors(),
    ...getHTMLErrors(),
    ...getQuestionErrors()
  ];
  XAPIMetadataErrors.value = getMetadataErrors();
  XAPIQuestionsWarnings.value = [...getQuestionWarnings()];
};
const checkXAPI = async (): Promise<void> => {
  if (uiContentStore.sectionToDisplay) {
    const allErrors: XAPIErrors = product.value
      ? await xApiHelper.validateBuildXAPI(product.value)
      : {
          contentErrors: [],
          contentTemplatesErrors: [],
          contentWarnings: []
        };
    uiContentStore.setXAPIErrors({
      productId: uiContentStore.sectionToDisplay.productId,
      ...allErrors
    });
    collectXAPIErrors();
  }
};
let oldVal = uiContentStore.XAPIErrors;
uiContentStore.$subscribe((mutation, state) => {
  const newVal = state.XAPIErrors;
  if (newVal) {
    if (route.name === "content" && !isEqual(newVal, oldVal)) {
      collectXAPIErrors();
      oldVal = newVal;
    }
  }
});
uiContentStore.$subscribe((mutation, state) => {
  const newVal = state.sectionToDisplay;
  if (newVal) {
    if (route.name === "content" && newVal) {
      collectXAPIErrors();
    }
  }
});
watch(
  () => product.value,
  newVal => {
    if (newVal && newVal.is_xapi && route.name !== "content") {
      checkXAPI();
    }
  }
);
onMounted(() => {
  if (product.value && product.value.is_xapi) {
    if (route.name !== "content") {
      checkXAPI();
    } else {
      collectXAPIErrors();
    }
  }
});

const removeContent = () => {
  if (section.value && uiContentStore.sectionToDisplay) {
    contentStore.deleteSection({
      productId: uiContentStore.sectionToDisplay.productId,
      sectionsId: section.value.id
    });
  }
  uiContentStore.closeContentSidebar();
};
const confirmRemoval = (): void => {
  showDialog({
    message: "Are you sure you want to continue?",
    cancelText: "No",
    confirmText: "Yes",
    onConfirm: () => {
      removeContent();
    }
  });
};

const previewAttachment = (fileLocation: string): void => {
  if (uiContentStore.isContentSidebarExpanded) {
    uiContentStore.toggleContentSidebarWidth();
  }
  uiContentStore.setFileLocationToPreview(fileLocation);
};
const closeSidebar = (): void => {
  if (uiContentStore.fileLocationForPreview) {
    uiContentStore.setFileLocationToPreview(undefined);
  }
  uiContentStore.closeContentSidebar();
};

const { hasDeployButton } = useFeatureFlags();
const hasQTIAuthoring = computed<boolean>(() => {
  return !!section.value && TOOLS.isQTITool(section.value.type.tool_id);
});
const isDeployButtonShown = computed<boolean | undefined>(() => {
  return (
    !!uiContentStore.sectionToDisplay &&
    hasDeployButton(
      hasQTIAuthoring.value,
      uiContentStore.sectionToDisplay.productId
    )
  );
});
const showDeployToQAError = () => {
  showToast({
    duration: 10000,
    message: section.value
      ? `${SECTION.ERRORS.deployingToQA} ${section.value.name}`
      : `${SECTION.ERRORS.deployingToQA}`,
    type: "is-danger"
  });
};
const deployToQA = (): void => {
  if (section.value?.authored_document_id) {
    contentAPI
      .deployToQA(section.value.authored_document_id, section.value.name)
      .then((response: AxiosResponse): void => {
        if (response.status === 200) {
          showToast({
            duration: 10000,
            message: section.value
              ? `${section.value.name} ${MESSAGES.SUCCESS.deployed}`
              : `${MESSAGES.SUCCESS.deployed}`,
            type: "is-success"
          });
        } else {
          showDeployToQAError();
        }
      })
      .catch((): void => {
        showDeployToQAError();
      });
  }
};

const isCloseButtonVisible = computed<boolean>(() => {
  return (
    !!uiContentStore.sectionToDisplay &&
    uiContentStore.sectionToDisplay.hasCloseButton
  );
});

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!

  return (section.value)
    ? (_openBlock(), _createBlock(RightSidebar, {
        key: 0,
        onCloseSidebar: closeSidebar,
        "data-testing": 'section-sidebar',
        "close-btn-data-testing": 'close-right-sidebar',
        "is-updating": isUpdating.value,
        "is-close-btn-visible": isCloseButtonVisible.value,
        "css-classes": [
      'content-sidebar',
      {
        closeBtnVisible: isCloseButtonVisible.value,
        externalContentOpened: _unref(uiContentStore).fileLocationForPreview,
        expanded: _unref(uiContentStore).isContentSidebarExpanded
      }
    ]
      }, {
        "additional-content": _withCtx(() => [
          (_unref(uiContentStore).fileLocationForPreview)
            ? (_openBlock(), _createBlock(ContentPreview, {
                key: 0,
                section: section.value,
                path: path.value[1],
                onClosePreview: _cache[0] || (_cache[0] = ($event: any) => (_unref(uiContentStore).setFileLocationToPreview(undefined)))
              }, null, 8, ["section", "path"]))
            : _createCommentVNode("", true)
        ]),
        "expand-btn": _withCtx(() => [
          (!_unref(uiContentStore).fileLocationForPreview)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "expand-btn btn-1",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(uiContentStore).toggleContentSidebarWidth && _unref(uiContentStore).toggleContentSidebarWidth(...args)))
              }, [
                (!_unref(uiContentStore).isContentSidebarExpanded)
                  ? (_openBlock(), _createBlock(_component_SVGIcon, {
                      key: 0,
                      path: _unref(mdiChevronLeft),
                      size: 18,
                      type: "is-white"
                    }, null, 8, ["path"]))
                  : (_openBlock(), _createBlock(_component_SVGIcon, {
                      key: 1,
                      path: _unref(mdiChevronRight),
                      size: 18,
                      type: "is-white"
                    }, null, 8, ["path"]))
              ]))
            : _createCommentVNode("", true)
        ]),
        title: _withCtx(() => [
          _createVNode(ContentName, {
            "content-name": section.value.name,
            "product-id": _unref(uiContentStore).sectionToDisplay.productId,
            "section-id": _unref(uiContentStore).sectionToDisplay.sectionId,
            "can-edit-content": canEditContent.value
          }, null, 8, ["content-name", "product-id", "section-id", "can-edit-content"])
        ]),
        dropdown: _withCtx(() => [
          (_unref(usersStore).canUserManageWorkflows && canEditContent.value)
            ? (_openBlock(), _createBlock(_component_b_dropdown, {
                key: 0,
                class: "is-block sidebar-dropdown-menu",
                "aria-role": "menu",
                position: "is-bottom-left",
                hoverable: true,
                "mobile-modal": false
              }, {
                trigger: _withCtx(() => [
                  _createElementVNode("button", _hoisted_1, [
                    _createVNode(_component_SVGIcon, {
                      path: _unref(mdiDotsHorizontal),
                      type: "is-white",
                      size: 32
                    }, null, 8, ["path"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (isDeployButtonShown.value)
                      ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                          key: 0,
                          "aria-role": "menu-item",
                          focusable: false,
                          custom: true
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              onClick: deployToQA,
                              class: "btn-unstyled btn-3 full-width"
                            }, [
                              _createVNode(_component_SVGIcon, { path: _unref(mdiPackageUp) }, null, 8, ["path"]),
                              _createTextVNode(" Deploy to QA ")
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_b_dropdown_item, {
                      "aria-role": "menu-item",
                      focusable: false,
                      custom: true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn-unstyled btn-3 full-width",
                          type: "button",
                          "data-testing": "state-delete-btn",
                          onClick: confirmRemoval
                        }, [
                          _createVNode(_component_SVGIcon, { path: _unref(mdiDelete) }, null, 8, ["path"]),
                          _createTextVNode(" Delete Content ")
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(AuthoringTool, {
                  section: section.value,
                  product: product.value,
                  "is-a-content-object": isAContentObject.value,
                  XAPIErrors: XAPIAuthoringToolErrors.value,
                  XAPIWarnings: XAPIQuestionsWarnings.value,
                  onPreviewAttachment: previewAttachment
                }, null, 8, ["section", "product", "is-a-content-object", "XAPIErrors", "XAPIWarnings"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(ContentIdentifiers, {
                  "internal-id": section.value.id,
                  "external-id": 
                section.value.client_external_id ? section.value.client_external_id : ''
              ,
                  sections: product.value.sections,
                  "can-edit-content": canEditContent.value,
                  "product-id": _unref(uiContentStore).sectionToDisplay.productId
                }, null, 8, ["internal-id", "external-id", "sections", "can-edit-content", "product-id"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(ContentLocation, {
                  product: product.value,
                  path: path.value,
                  "section-name": section.value.name,
                  "section-id": section.value.id,
                  "section-icon-id": section.value.type.icon_id,
                  "section-external-id": sectionExternalId.value,
                  "can-edit-content": canEditContent.value
                }, null, 8, ["product", "path", "section-name", "section-id", "section-icon-id", "section-external-id", "can-edit-content"])
              ]),
              (showContentDescription.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(ContentDescription, {
                      "product-id": _unref(uiContentStore).sectionToDisplay.productId,
                      "section-id": _unref(uiContentStore).sectionToDisplay.sectionId,
                      section: section.value,
                      "can-edit-content": canEditContent.value
                    }, null, 8, ["product-id", "section-id", "section", "can-edit-content"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (isMetadataVisible.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(ContentMetadata, {
                      "is-updating": isUpdating.value,
                      product: product.value,
                      section: section.value,
                      "displayed-metadata": displayedMetadata.value,
                      "can-edit-content": canEditContent.value,
                      XAPIErrors: XAPIMetadataErrors.value
                    }, null, 8, ["is-updating", "product", "section", "displayed-metadata", "can-edit-content", "XAPIErrors"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (canShowWorkflow.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(ContentWorkflow, {
                      product: product.value,
                      workflowStates: workflowStates.value,
                      "current-state": currentState.value,
                      "workflow-state-from-title-id": 
                _unref(uiContentStore).sectionToDisplay.workflowStateId
              ,
                      section: section.value,
                      "is-updating": isUpdating.value
                    }, null, 8, ["product", "workflowStates", "current-state", "workflow-state-from-title-id", "section", "is-updating"])
                  ]))
                : _createCommentVNode("", true),
              (hasWorkflowStates.value && workflowStates.value.length && section.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(ContentActivityLog, {
                      section: section.value,
                      workflowStates: workflowStates.value,
                      "product-id": _unref(uiContentStore).sectionToDisplay.productId,
                      "section-id": _unref(uiContentStore).sectionToDisplay.sectionId
                    }, null, 8, ["section", "workflowStates", "product-id", "section-id"])
                  ]))
                : _createCommentVNode("", true),
              (isCurriculumTagsVisible.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(CurriculumTags, {
                      section: section.value,
                      "product-curriculum-id": product.value.curriculum_id,
                      "is-loading": _unref(isCurriculumLoading),
                      "topics-from-xml": _unref(topicsFromXml),
                      "concepts-from-xml": _unref(conceptsFromXml),
                      "xml-parsed-successfully": _unref(xmlParsedSuccessfully),
                      "can-edit-content": canEditContent.value
                    }, null, 8, ["section", "product-curriculum-id", "is-loading", "topics-from-xml", "concepts-from-xml", "xml-parsed-successfully", "can-edit-content"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        modals: _withCtx(() => [
          (_unref(uiContentStore).isEditContentPathModalOpen)
            ? (_openBlock(), _createBlock(EditContentPath, {
                key: 0,
                path: path.value,
                "section-name": section.value.name,
                "section-id": section.value.id,
                "section-icon-id": section.value.type.icon_id,
                product: product.value,
                structure: structure.value,
                "section-external-id": sectionExternalId.value
              }, null, 8, ["path", "section-name", "section-id", "section-icon-id", "product", "structure", "section-external-id"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-updating", "is-close-btn-visible", "css-classes"]))
    : _createCommentVNode("", true)
}
}

})